import { render, staticRenderFns } from "./SystemBans.vue?vue&type=template&id=e621b6ba&scoped=true"
import script from "./SystemBans.vue?vue&type=script&lang=js"
export * from "./SystemBans.vue?vue&type=script&lang=js"
import style0 from "./SystemBans.vue?vue&type=style&index=0&id=e621b6ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e621b6ba",
  null
  
)

export default component.exports